import React, { useState, useEffect, useRef } from 'react';

const TextForCell = ({ text, type, elementClassName = '', tooltip }) => {
  const [addElipsis, setAddElipsis] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setAddElipsis(el.scrollWidth > el.offsetWidth);
    };

    checkOverflow();

    const resizeObserver = new window.ResizeObserver(() => {
      checkOverflow();
    });
    resizeObserver.observe(el);

    window.addEventListener('resize', checkOverflow);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', checkOverflow);
    };
  }, [text, type, elementClassName]);

  if (!text) return null;
  const textForTooltip = typeof text === 'object' ? text.props?.children?.[0]?.props?.children : text;

  return (
    <div
      ref={containerRef}
      style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
      className={`${type === 'title' ? 'crm-table-item-title' : ''}`}
      data-tooltip-content={addElipsis || tooltip ? (tooltip ?? textForTooltip) : undefined}
      data-tooltip-id={addElipsis || tooltip ? 'general-tooltip' : undefined}
      data-tooltip-class-name={
        addElipsis || tooltip ? 'header-tooltip pricing-tooltip-description table-item-cell-tooltip' : undefined
      }
    >
      <span className={`${elementClassName}`}>{text}</span>
    </div>
  );
};

export default TextForCell;
